module.exports = __webpack_public_path__ + "static/media/medicine-problems-to-avoid.66141c2e.md";


//////////////////
// WEBPACK FOOTER
// ./src/md/medicine-problems-to-avoid.md
// module id = 2886
// module chunks = 0